import { Box, Checkbox, FormControl, FormLabel } from '@mui/material';
import React from 'react';

interface ROICheckboxItemProps {
    roi: string;
    checked: boolean;
    onChange: (checked: boolean) => void;
}

const ROICheckboxItem: React.FC<ROICheckboxItemProps> = ({
    roi,
    checked,
    onChange,
}) => {
    return (
        <FormControl
            onClick={() => onChange(!checked)}
            sx={{
                flexDirection: 'row',
                alignItems: 'center',
                overflow: 'hidden',
                width: '100%',
                cursor: 'pointer',
                '&:hover': {
                    backgroundColor: 'action.hover',
                },
            }}
        >
            <Box onClick={(e) => e.stopPropagation()} sx={{ lineHeight: 1 }}>
                <Checkbox
                    checked={checked}
                    onChange={(e) => onChange(e.target.checked)}
                    size="small"
                />
            </Box>
            <FormLabel
                sx={{
                    fontSize: 11,
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    userSelect: 'none',
                    cursor: 'pointer',
                    lineHeight: 1,
                }}
            >
                {roi}
            </FormLabel>
        </FormControl>
    );
};

export default ROICheckboxItem;
